import * as React from 'react';
import { useTranslation } from 'react-i18next';
import {
  CreatableCombobox as BbCombobox,
  ComboboxProps as BbComboboxProps,
  ComboboxOption,
  ComboboxGroup,
} from '@bb-ui/react-library';

export interface ComboboxProps extends Omit<
  BbComboboxProps<ComboboxOption, ComboboxGroup<ComboboxOption>>,
  'strings' | 'onChange'
> {
  onChange?: (values: ComboboxOption[]) => void;
}

export const Combobox = (props: ComboboxProps) => {
  const { t } = useTranslation();
  const isMulti = true;

  return (
    <BbCombobox
      {...props}
      isMulti={isMulti}
      isClearable
      strings={{
        announceOptionSelected: (option) =>
          t('global.comboboxComponent.announceSelected', { label: option.label }),
        announceOptionDeselected: (option) =>
          t('global.comboboxComponent.announceDeSelected', { label: option.label }),
        announceSearchResults: (count, searchString) => {
          if (count === 0) {
            return t('global.comboboxComponent.noResultsFound', { searchString });
          }
          if (count === 1) {
            return t('global.comboboxComponent.foundOneResult', { count, searchString });
          }
          return t('global.comboboxComponent.foundMultipleResults', { count, searchString });
        },
        announceValueCleared: t('global.comboboxComponent.announceValueCleared'),
        clearButtonLabel: t('global.comboboxComponent.clearButtonLabel'),
        noResults: (searchString) => t('global.comboboxComponent.noResultsFound', { searchString }),
        searchLabel: t('global.search'),
        createOptionLabel: (searchString) =>
          t('global.comboboxComponent.createOptionLabel', { label: searchString }),
      }}
    />
  );
};
